
























































































































































































































































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { getHubConnection } from "@/services/signalr";
import moment from "moment";



@Component({
  components: {

  },
  computed: {

  },
})
export default class CensusListView extends Vue {
  table = this.$route.params.t;
  updateConfig = true;
  //
  refreshTimer: number | null = null;
  refreshDelay = 10000 // 30 seconds
  //pagination
  statusPage = 0;
  statusPageSize = 0;
  statusInterval: any = null;

  censusPage = 0;
  censusPageSize = 0;
  censusInterval: any = null;

  //
  //
  hub = getHubConnection("waitinglist");
  groupName = this.$route.params.t;

  config = {
    "layoutId": 1,
    "updateInterval": 30,
    "paginationInterval": 10,
    "header": {
      "image": 296856,
      "title": "Census Dashboard",
      "color": {
        "font": "#FFFFFF",
        "back": "#1E3A8A"
      }
    },
    "censusSummary": {
      "title": "Total Census",
      "color": {
        "font": "#fff",
        "back": "#343a40"
      }
    },
    "footer": {
      "image": 18642,
      "text": "Copyright © 2025 AdlightTech™ | All Rights Reserved",
      "color": {
        "font": "#FFFFFF",
        "back": "#111827"
      }
    }
  };
  key = "";
  result = "";
  showAuthorize = false;
  showNotFound =false;
  census: any = [];
  statusList: any = [];
  admissionSummary: any = [];
  pageTimer: any = null;
  checkPlaylist = this.$route.params.p ? false : true;

  colors = [
    { back: "#007bff", font: "##FFFFFF" },
    { back: "#FF8C33", font: "##FFFFFF" }, // naranja
    { back: "#33FF57", font: "#000000" }, // verde brillante
    { back: "#3357FF", font: "#FFFFFF" }, // azul intenso
    { back: "#FF33A8", font: "#FFFFFF" }, // rosa fuerte
    { back: "#33FFF5", font: "#000000" }, // cyan
    { back: "#F5FF33", font: "#000000" }, // amarillo
    { back: "#8C33FF", font: "#FFFFFF" }, // morado
    { back: "#33FF8C", font: "#000000" }, // verde menta
    { back: "#FF33F6", font: "#FFFFFF" }, // fucsia
    { back: "#33A8FF", font: "#000000" }, // azul celeste
    { back: "#FFC300", font: "#000000" }, // dorado
    { back: "#33FFB5", font: "#000000" }, // verde agua
    { back: "#8CFF33", font: "#000000" }, // verde lima
    { back: "#FFB533", font: "#000000" }, // naranja claro
    { back: "#33D1FF", font: "#000000" }  // azul claro
  ];

  @Watch("census", { deep: true })
  onFilterChanged() {
    //this.startPagination();
  }


  async getCensus() {
    try {
      const { lastCensus, statusList, admissionSummary, config } = await this.$store.dispatch("schedule/getWaitingListCensus", this.table);
      if (lastCensus == null) {
       this.showNotFound=true;
      }else{
        this.showNotFound=false;
      }

      this.census = lastCensus.concat(admissionSummary);
      this.statusList = statusList;
      this.admissionSummary = admissionSummary;
      if (this.updateConfig) {
        //console.log("updateConfig");
        
        this.config = Object.assign({}, this.config, config);//config; 
        this.updateConfig = false;
        this.startPagination();
      }
      this.startTimer();
    } catch (err) {

      const error = err as { status?: number; message?: string; data?: any };

      if (error.status === 403) {
        this.showAuthorize = true;
      } else {
        console.log(error);
      }
    }
  }

  async authorize() {
    var data = await this.$store.dispatch("auth/deviceAuthorize", this.key);
    if (data.token) {
      localStorage.setItem("deviceToken", data.token);
      this.showAuthorize = false;
      this.getCensus();
    } else {
      //this.result = "TEST";
    }

  }


  async getFile(id) {
    try {
      var data = await this.$store.dispatch("schedule/getContentFile", id);
      return data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  getURL(id) {
    return process.env.VUE_APP_ROOT_API + "/schedule/wmpc/content/file/" + id;
  }

  totalCensus() {
    return this.statusList.reduce((sum, item) => sum + (item.count || 0), 0);
  }

  //pagination
  get paginatedStatusList() {
    if (this.statusPageSize === 0 || this.statusList.length <= this.statusPageSize) {
      return this.statusList;
    }
    const start = this.statusPage * this.statusPageSize;
    return this.statusList.slice(start, start + this.statusPageSize);
  }

  get paginatedCensus() {
    if (this.censusPageSize === 0 || this.census.length <= this.censusPageSize) {
      return this.census;
    }
    const start = this.censusPage * this.censusPageSize;
    return this.census.slice(start, start + this.censusPageSize);
  }

  startStatusPagination() {
    if (this.statusInterval) clearInterval(this.statusInterval);

    const headerHeight = document.querySelector(".header")?.clientHeight || 180;
    const footerHeight = document.querySelector(".footer")?.clientHeight || 140;
    const censoHeight = document.querySelector(".censo-container")?.clientHeight || 0;
    const availableHeight = window.innerHeight - headerHeight - censoHeight - footerHeight - 40;
    const cardsContainer = document.querySelector(".cards-container") as HTMLElement;
    const card = cardsContainer?.querySelector(".card") as HTMLElement;
    const cardHeight = card?.offsetHeight + 20 || 120;
    const cardWidth = card?.offsetWidth || 380;
    const containerWidth = cardsContainer?.clientWidth || window.innerWidth;
    const cardsPerRow = Math.floor(containerWidth / cardWidth) || 1;
    const rowsPerPage = Math.floor(availableHeight / cardHeight);

    this.statusPageSize = cardsPerRow * rowsPerPage;
    this.statusPage = 0;

    if (this.statusList.length > this.statusPageSize) {
      this.statusInterval = setInterval(() => {
        this.statusPage =
          (this.statusPage + 1) %
          Math.ceil(this.statusList.length / this.statusPageSize);
      }, this.config.paginationInterval * 1000);
    }
  }

  startCensusPagination() {
    if (this.censusInterval) clearInterval(this.censusInterval);

    const headerHeight = document.querySelector(".header")?.clientHeight || 180;
    const footerHeight = document.querySelector(".footer")?.clientHeight || 140;
    const censoHeight = document.querySelector(".censo-container")?.clientHeight || 0;
    const availableHeight = window.innerHeight - headerHeight - censoHeight - footerHeight - 40;
    const extraInfo = document.querySelector(".extra-info");
    const card = extraInfo?.querySelector(".extra-card") as HTMLElement;
    const cardHeight = card?.offsetHeight + 15 || 64; //64

    this.censusPageSize = Math.floor(availableHeight / cardHeight);
    this.censusPage = 0;

    if (this.census.length > this.censusPageSize) {
      this.censusInterval = setInterval(() => {
        this.censusPage = (this.censusPage + 1) % Math.ceil(this.census.length / this.censusPageSize);
        const start = this.censusPage * this.censusPageSize;

      }, this.config.paginationInterval * 1000);
    }
  }

  startPagination() {
    this.startStatusPagination();
    this.startCensusPagination();
  }
  //
  //signalr
  async setHub() {
    try {
      this.hub.onreconnected(() => {
        this.addToGroup();
      });
      this.hub.onclose(() => {
        // this.connected = false;
      });
      this.hub.onreconnecting(() => {
        //this.connected = false;
      });
      this.hub.on("listEvent", (event) => {
        /*event = JSON.parse(event);
        if (event.type == "RMD") {
          this.updateAppt(event);
        }*/
        this.resetTimer();
        this.getCensus();
      });
      await this.hub.start();
      await this.addToGroup();
    } catch (error) {
      console.log(error);
    }
  }



  async restartHub() {
    await this.removeFromGroup()
    await this.addToGroup();
  }

  async addToGroup() {
    try {
      await this.hub.invoke(
        "JoinGroup",
        this.groupName
      );
    } catch (error) {
      console.log(error);
    }
  }

  async removeFromGroup() {
    try {
      await this.hub.invoke(
        "RemoveFromGroup",
        this.groupName
      );
    } catch (error) {
      console.log(error);
      //this.connected = false;
    }
  }

  /*
  fetchData(){
    setInterval(() => {
      this.getCensus();
      console.log("auto refresh");
    }, 30000);
  }
*/
  startTimer() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }

    this.refreshTimer = window.setTimeout(() => {
      this.getCensus();
      console.log("auto refresh");
    }, this.config.updateInterval * 1000);
  }

  resetTimer() {
    console.log("resetTimer");
    this.startTimer(); // reutilizamos
  }



  //
  mounted() {
    this.getCensus();
    //this.startPagination();
    this.setHub();
    window.addEventListener("resize", () => {
      this.startPagination();
    });
    this.startTimer();

     document.body.classList.add("overflow-hidden");
  }

  beforeDestroy() {
    if (this.statusInterval) clearInterval(this.statusInterval);
    if (this.censusInterval) clearInterval(this.censusInterval);
    window.removeEventListener("resize", () => {
      this.startPagination();
    });
  }

  beforeUnmount() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }

    document.body.classList.remove("overflow-hidden");
  }

}
